import moment from 'moment'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getData } from '../../../Service/ApiMethod'
import { UNLOCKED_PROFILESS } from '../../../Service/service'
import UnlockedProfileBlackScreen from '../UnlockedProfileBlackScreen'
import RoundsPopup from './RoundsPopup'
import { useTranslation } from "react-i18next";
import { lang } from '../../../lang'


const UnlockedProfiles = () => {
  const [detail, setDeatil] = useState()
  const [roundpopup, setRoundPopup] = useState(false)
  const [unlockProfileId, setUnlockProfileId] = useState()
  const [blackScreenPopup, setBlackScreenPopup] = useState(false)
  const [ iindex, setIindex] = useState()
  const [ roundIndex, setROundIndex] = useState()
  const [ popup , setPopup] = useState(false)
  const ln = localStorage.getItem("language") == null ? "en":localStorage.getItem("language")
  const location = useLocation()
  console.log(ln,"chddd")
  const getUnlockedProfile = () => {
    getData(UNLOCKED_PROFILESS+ "?pgNo=" + 1 + "&keyword=" + "" + "&filter=" + 0) 
      .then((response) => response.json())
      .then((res) => {
        console.log('unlocked profiles data', res.data)
        if(location?.pathname == '/home'){
          setDeatil((res.data.unlocked_profile).slice(0, 4))
        }else{
        setDeatil(res.data.unlocked_profile)
        }
       
      })
      .catch((err) => {
        console.log('Error in categories from Post Form', err);
        console.log(' code Error', err);
      })
  }

  // console.log(detail)
  console.log(unlockProfileId, 'id')
  console.log('hi', unlockProfileId)
  console.log('user details', detail)

  useEffect(() => {
    getUnlockedProfile()
  }, [])

  useEffect(() => {
    getUnlockedProfile()
  }, [blackScreenPopup])

  useEffect(() => {
    getUnlockedProfile()
  }, [popup])

  const {t} = useTranslation()
  console.log('ossssss',ln)

  return (
    <>
      {detail != undefined
        ? detail?.map((item, index) => {
          // console.log(item)
          return (
            <div
              className="col-lg-3 col-md-4 col-sm-6 flex-center"
              key={index}
              onClick={(e)=>{
                e.stopPropagation()
                setBlackScreenPopup(true)
                setIindex(index)
              }}
            >
              <div className="unlocked-profile w-100">
                <div className="unlocked-profile-boxx relative flex-center ">
                {item?.is_premium &&
                      <div style={{position:'absolute', top:'0', left:'0'}}>
                      <img
                      src="./images/premium-tag.png"
                      className="premium-tag"
                      // title="Call"
                      alt=""
                    />
                      </div>
                      }
                  <img
                    src={item?.cand_image || "./images/Vector.png"}
                    alt=""
                    className="unlocked-profile-img img-fluid"
                  />
                  <img
                    onClick={(e) => {
                      e.stopPropagation()
                      setRoundPopup(true)
                      setROundIndex(index)
                      setUnlockProfileId(e.target.id)
                    }}
                    src="./images/save-profile.png"
                    alt=""
                    style={{cursor:"pointer",width:30}}
                    id={item?.candidate_id}
                    className="save-profile"
                  />
                  <p className="hire-status">{item?.round_status == "Unlocked" ? lang && Object.keys(lang).length > 0 ? lang[ln]?.Lastest[item?.round_status] : 'Unlocked':t(item?.round_status)}</p>
                  <div className="profile-match horizontal-center">
                    <img
                      src="./images/match-badge.png"
                      className=" mr-1"
                      alt=""
                      style={{width:13}}
                    />
                    <span className="match-score">
                      {parseInt(item?.percentage_match)} %
                    </span>
                  </div>
                </div>

                <h2 className="card-heding mt-4">
                  {item?.first_name} {item?.last_name}
                </h2>
                <p className="designation">
                  {item?.profile_title}
                </p>
                <div className="unlocked-status unlockedstatus">
                  <p className="unlocked-time">
                    {t('Unlocked on')} {moment(item?.unlocked_on).format('D MMM YYYY, h:mm A')}
                  </p>
                </div>
                {/* {detail != undefined ? detail.first_name : null} */}

                <div className="row mt-3">
                  <div
                    className="col-6 px-0"
                    style={{ borderRight: '1px solid #0000004d'}}
                  >
                    <p className="profile-info text-center" style={{ height:'20px' }}>
                      {item?.experience_id} {(parseInt(item?.experience_id)>1)?`${lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Years']:""}`:`${lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Year']:""}`}
                    </p>
                    <span className="card-subHeading text-center mt-6">
                      {lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Total Experience']:""}
                    </span>
                  </div>
                  <div className="col-6 px-0">
                    <p className="profile-info text-center" style={{ height:'20px', textAlign:'center' }}>
                      {/* {item?.candidate[0]?.address} */}
                      {parseInt(item?.distance)} {t('KM Away')}
                    </p>
                    <span className="card-subHeading text-center mt-6">
                      {lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Current Location']:""}
                    </span>
                  </div>

                  {/**  {detail !== undefined
        ? detail.map((item) => {
            return (
              <div>
                <p>{item.candidate.first_name}</p>
              </div>
            );
          })
        : null} */}
                  <div className="col-6 px-0"></div>
                  <div className="col-6 px-0"></div>
                </div>
              </div>
              {((iindex == index) && blackScreenPopup) &&
                  <div className='blur-screen-full-area flex-center' style={{ position: 'fixed', top: '0', zIndex: '99999999999999', height: '100vh', background:'rgb(0, 0, 0, 0.7' }}>
                     <UnlockedProfileBlackScreen item={item} setBlackPopupValue={setBlackScreenPopup} />
                  </div>
                }
              {/* {blackScreenPopup && 
              <UnlockedProfileBlackScreen item={item} setBlackPopupValue={setBlackScreenPopup} />} */}
                 {roundpopup && roundIndex == index  &&(
        <RoundsPopup
          handleRoundStatus={(e) => {
            console.log(e.target.name, 'name')
          }}
          setPopup= {setPopup}
          popup ={popup}
          closePopup={setRoundPopup}
          unlockId={unlockProfileId}
          SeekerID= {item?.candidate_id}
        /> 
      )}
            </div>
          )
        })
        : null}
   
    </>
  )
}

export default UnlockedProfiles
